import {PersonalInformationUpdate} from './personal-information-update';
import {ContactPermission} from './contact-permission.enum';
export class MemberUpdate {
  constructor(public mailContactPermission: ContactPermission,
              public mobileContactPermission: ContactPermission,
              public personalInformation: PersonalInformationUpdate) {
  }
}
